import { render, staticRenderFns } from "./cost_activity.vue?vue&type=template&id=4889894c&scoped=true"
import script from "./cost_activity.vue?vue&type=script&lang=js"
export * from "./cost_activity.vue?vue&type=script&lang=js"
import style0 from "./cost_activity.vue?vue&type=style&index=0&id=4889894c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889894c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4889894c')) {
      api.createRecord('4889894c', component.options)
    } else {
      api.reload('4889894c', component.options)
    }
    module.hot.accept("./cost_activity.vue?vue&type=template&id=4889894c&scoped=true", function () {
      api.rerender('4889894c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_detail/components/cost_activity.vue"
export default component.exports